"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectDataFacade = void 0;
const rxjs_1 = require("rxjs");
const elf_1 = require("@ngneat/elf");
const project_store_1 = require("../state/project.store");
class ProjectDataFacade {
    constructor(projectService) {
        this.projectService = projectService;
        this.project$ = project_store_1.projectStore.pipe((0, elf_1.select)((state) => state));
        this.projectService = projectService;
    }
    fetchCampaigns() {
        (0, rxjs_1.from)(this.projectService.fetchCampaigns()).subscribe((result) => {
            if (result !== null) {
                project_store_1.projectStore.update((0, elf_1.setProp)('campaigns', result));
            }
        });
    }
    fetchTemplates(campaignId) {
        (0, rxjs_1.from)(this.projectService.fetchTemplates(campaignId)).subscribe((result) => {
            if (result !== null) {
                project_store_1.projectStore.update((0, elf_1.setProps)((state) => (Object.assign(Object.assign({}, state), { templates: Object.assign(Object.assign({}, state.templates), { [campaignId]: result }) }))));
            }
        });
    }
}
exports.ProjectDataFacade = ProjectDataFacade;
//# sourceMappingURL=project.facade.js.map